module.exports = __webpack_public_path__ + "static/media/backgroundImg4.b5f22d1d.jpg";